var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import axios from "axios";
import environment from "./config/environment";
const apiUrl = environment.getApiUrl();
class ApiClient {
    constructor() {
        const baseURL = apiUrl;
        this.client = axios.create({
            baseURL,
            headers: {
                "Content-Type": "application/json",
            },
        });
    }
    getEvent(code) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const response = yield this.client.get(`/events/${code}`);
                return response.data;
            }
            catch (error) {
                this.handleError(error);
            }
        });
    }
    createUpload(data) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const response = yield this.client.post(`/uploads`, data);
                return response.data;
            }
            catch (error) {
                this.handleError(error);
            }
        });
    }
    createGuest(data) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const response = yield this.client.post(`/guests`, data);
                return response.data;
            }
            catch (error) {
                this.handleError(error);
            }
        });
    }
    updateGuest(id, data) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const response = yield this.client.post(`/guests/${id}/update`, data);
                return response.data;
            }
            catch (error) {
                this.handleError(error);
            }
        });
    }
    createQuizResult(data) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const response = yield this.client.post(`/games/quiz`, data);
                return response.data;
            }
            catch (error) {
                this.handleError(error);
            }
        });
    }
    createPhotoChallenge(data) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const response = yield this.client.post(`/games/photoChallenges`, data);
                return response.data;
            }
            catch (error) {
                this.handleError(error);
            }
        });
    }
    createTeamMatch(data) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const response = yield this.client.post(`/games/teamMatches`, data);
                return response.data;
            }
            catch (error) {
                this.handleError(error);
            }
        });
    }
    createBingoResult(data) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const response = yield this.client.post(`/games/bingo`, data);
                return response.data;
            }
            catch (error) {
                this.handleError(error);
            }
        });
    }
    getFeed(code) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const response = yield this.client.get(`/events/${code}/feed`);
                return response.data;
            }
            catch (error) {
                this.handleError(error);
            }
        });
    }
    feedEventLike(code, feedId, params) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const response = yield this.client.post(`/events/${code}/feed/${feedId}/like`, params);
                return response.data;
            }
            catch (error) {
                this.handleError(error);
            }
        });
    }
    feedEventDislike(code, feedId, params) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const response = yield this.client.post(`/events/${code}/feed/${feedId}/dislike`, params);
                return response.data;
            }
            catch (error) {
                this.handleError(error);
            }
        });
    }
    getFeedV2(code, limit, lastDocId) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const params = new URLSearchParams();
                if (limit) {
                    params.append("limit", limit.toString());
                }
                if (lastDocId) {
                    params.append("lastDocId", lastDocId);
                }
                const queryString = params.toString();
                const url = `/events/${code}/feed/v2${queryString ? `?${queryString}` : ""}`;
                const response = yield this.client.get(url);
                return response.data;
            }
            catch (error) {
                this.handleError(error);
            }
        });
    }
    feedV2EventLike(code, feedId, params) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const response = yield this.client.post(`/events/${code}/feed/v2/${feedId}/like`, params);
                return response.data;
            }
            catch (error) {
                this.handleError(error);
            }
        });
    }
    feedV2EventDislike(code, feedId, params) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const response = yield this.client.post(`/events/${code}/feed/v2/${feedId}/dislike`, params);
                return response.data;
            }
            catch (error) {
                this.handleError(error);
            }
        });
    }
    feedV2EventDelete(code, feedId, params) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const response = yield this.client.post(`/events/${code}/feed/v2/post/${feedId}/delete`, params);
                return response.data;
            }
            catch (error) {
                this.handleError(error);
            }
        });
    }
    createFeedPost(data) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const response = yield this.client.post(`/events/${data.eventCode}/feed/v2/post`, data);
                return response.data;
            }
            catch (error) {
                this.handleError(error);
            }
        });
    }
    getEventRanking(eventId) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const response = yield this.client.get(`/events/${eventId}/ranking`);
                return response.data;
            }
            catch (error) {
                this.handleError(error);
            }
        });
    }
    getGuestRanking(eventId, guestId) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const response = yield this.client.get(`/events/${eventId}/ranking/guest/${guestId}`);
                return response.data;
            }
            catch (error) {
                this.handleError(error);
            }
        });
    }
    handleError(error) {
        if (error.response) {
            console.error("Error response:", error.response.data);
        }
        else if (error.request) {
            console.error("Error Request:", error.request);
        }
        else {
            console.error("Error unexpected: ", error.message);
        }
        console.error("Error Config:", error.config);
    }
}
export default ApiClient;
